<div class="containerInserimentoLicord">
    <form id="contact" style="margin-bottom: 8px; width: 100%">
        <h3 style="text-align:center">Inserimento Tecnici</h3>
        <h4 style="text-align:center">Assegna un tecnico al cantiere</h4>    
        <div class="containerFormLicord">
            <div>
                <p>
                    <mat-form-field appearance="outline" class="byclass">
                        <mat-label>Email utente</mat-label>
                        <mat-select (selectionChange)="updateAccountkey($event.value)" autofocus>
                            <mat-option *ngFor="let i of accounts" [value]="i.account_key">{{ i.ac_email }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </p>
                <fieldset
                    style="
                        margin-top: 20px;
                        margin-bottom: -40px
                    "
                >
                    <button 
                        (click)="assignAccount()"
                        class="btn-add" 
                        id="contact-submit"
                        type="submit" 
                        name="submit" 
                        data-submit="...Sending" 
                    >
                        <mat-icon 
                            style="
                                margin-right: 25px; 
                                transform: scale(2.3);
                                position: relative;
                                top: 2px
                            "
                        >cloud_upload</mat-icon>
                        <span 
                            style="
                                position: relative; 
                                top: -3px
                            "
                        >ASSEGNA</span>
                    </button>
                    <button 
                        data-submit="...Sending" 
                        (click)="close()"
                        class="btn-annulla"
                        id="contact-submitt"
                        type="submit" 
                        name="submit" 
                    >
                        <mat-icon 
                            style="
                                margin-right: 25px; 
                                transform: scale(2.3);
                                position: relative;
                                top: 2px
                            "
                        >clear</mat-icon>
                        <span 
                            style="
                                position: relative; 
                                top: -3px
                            "
                        >ANNULLA</span>
                    </button>
                </fieldset>
            </div>
        </div>
    </form>
</div>